var map = {
	"./AR.png": 7025,
	"./Automotive Solutions.png": 4267,
	"./Compliance and Certification.png": 3048,
	"./Consulting Services.jpg": 1246,
	"./Edge A.I Solutions.a1930f17d8c1cc75ab22.jpg": 2312,
	"./Edge A.I Solutions.jpg": 9245,
	"./Firmware Development.png": 6872,
	"./IOT Solutions.png": 66,
	"./Industrial 4.0 Solutions.png": 2779,
	"./Maintenance and Support.png": 2077,
	"./Manufacturing Support.jpg": 5017,
	"./SD-HD-Logo.svg.png": 2838,
	"./ai-chip.png": 2507,
	"./ai.png": 8178,
	"./ai1.png": 4657,
	"./automation.png": 1777,
	"./backgroundcard.png": 1450,
	"./backgroundimage.jpg": 1537,
	"./certified.png": 985,
	"./chip.png": 8754,
	"./compliance.png": 4129,
	"./consulting.png": 6420,
	"./consulting1.png": 1207,
	"./coveriamge.jpg": 76,
	"./customer-review.png": 4111,
	"./customer-support.png": 8294,
	"./cyber-security.png": 7750,
	"./digitalinfrahomewhiteicon.png": 5503,
	"./edge-computing.png": 3122,
	"./edgeai.png": 6065,
	"./embedded.png": 5138,
	"./embedded1.png": 4849,
	"./firmware.png": 811,
	"./firmware1.png": 1514,
	"./high-quality.png": 9068,
	"./industail4.0.png": 753,
	"./innovationkeys.jpg": 2973,
	"./intelligenceorange.png": 539,
	"./intelligencewhite.png": 3378,
	"./iot.png": 386,
	"./kmpslogo.png": 7358,
	"./kmpslogo.white.png": 8615,
	"./logo.jpg": 1769,
	"./maintanance.png": 379,
	"./maintenance.png": 5519,
	"./manufacturing.png": 4272,
	"./officepic.jpg": 5518,
	"./ourservicebgm.jpg": 689,
	"./prototype.png": 932,
	"./prototypeorange.png": 8098,
	"./quality1.png": 7712,
	"./software-developmentorange.png": 773,
	"./software-developmentwhite.png": 8636,
	"./softwaredevelopment.PNG": 4447
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;